// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleEditorIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path d="M5.54 7.1c0-2.66 2.08-4.73 4.61-4.73s4.62 2.07 4.62 4.73c0 2.54-2.08 4.61-4.62 4.61-2.53 0-4.61-2.07-4.61-4.61m8.6 11.72q.48.45 1.13.45.15 0 .28-.02l.98-.16q1-.18 1.69-.93L22 14c.71-.78.66-1.99-.11-2.7l-.9-.83c-.76-.7-1.98-.66-2.7.11l-3.83 4.22q-.61.7-.73 1.63l-.1 1c-.06.52.13 1.02.5 1.39" />
      <path
        d="M9.35 14.02c.46-.12.92.23 1.04.7l2.07 5.3c.35.8-.23 1.62-1.04 1.62H4.73c-.92 0-1.73-.35-2.3-.93-.58-.57-.93-1.38-.93-2.19 0-.8.23-1.62.7-2.2.45-.57 1.03-1.03 1.84-1.38 1.38-.57 3.23-.8 5.3-.92"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default RoleEditorIcon;
